import { render, staticRenderFns } from "./chatMessageView.vue?vue&type=template&id=3d6d9184&scoped=true"
import script from "./chatMessageView.vue?vue&type=script&lang=js"
export * from "./chatMessageView.vue?vue&type=script&lang=js"
import style0 from "./chatMessageView.vue?vue&type=style&index=0&id=3d6d9184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6d9184",
  null
  
)

export default component.exports